import { useEffect } from 'react';
import './ConfirmModal.scss';

interface ConfirmModalProps {
  title: string;
  children: React.ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

export function ConfirmModal({
  title,
  children,
  confirmLabel,
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
  loading = false,
}: ConfirmModalProps) {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && !loading) onCancel();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onCancel, loading]);

  return (
    <div className="confirm-modal" onClick={onCancel} role="dialog" aria-modal="true" aria-labelledby="confirm-modal-title">
      <div className="confirm-modal__content" onClick={(e) => e.stopPropagation()}>
        <h2 className="confirm-modal__title" id="confirm-modal-title">{title}</h2>
        <div className="confirm-modal__body">{children}</div>
        <div className="confirm-modal__actions">
          <button
            type="button"
            className="confirm-modal__btn confirm-modal__btn--secondary"
            onClick={onCancel}
            disabled={loading}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className="confirm-modal__btn confirm-modal__btn--danger"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Cancelling...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
